import React, { Component } from 'react';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';

import Layout from '../layout';

import styles from '../styles/pages/terms-conditions.scss';

import SignupPromotion from '../shared/signup-promotion';

class ReturnPolicy extends Component {
    constructor(props) {
        super(props);

        document.title = this.props.intl.formatMessage({ id: 'return-policy-title' });
    }

    componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) {
            document.title = this.props.intl.formatMessage({ id: 'return-policy-title' });
        }
    }

    render() {
        const Paragraph = (props) => (
            <div className="text-justify" style={{ paddingBottom: 10, ...props.style }}>
                {props.children}
            </div>
        );

        return (
            <Layout notShowMarginBottom>
                <div className="container">
                    <div className="row">
                        <h4 className={styles.mainText}>
                            <FormattedMessage id="term-and-conditions" defaultMessage="" />
                        </h4>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div className={styles.privacyBackround}>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="terms-conditions-title" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="terms-conditions-subheader1" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader1-subtitle1"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle1-text1"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <u>info@cubalicores.com</u>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle1-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader1-subtitle2"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle2-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle2-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle2-text3"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/settings"><u>https://www.cubalicores.com/settings</u></a>
                                    .
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle2-text4"
                                        defaultMessage=""
                                    />
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle2-text5"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader1-subtitle3"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle3-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle3-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle3-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle3-text4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader1-subtitle4"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text4-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text4-2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text4-3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text4-4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text5"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text6"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/return-policy">
                                        <u>
                                            <FormattedMessage
                                                id="return-policy"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    <FormattedMessage
                                        id="terms-conditions-subheader1-subtitle4-text7"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader2"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader2-subtitle1"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle1-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader2-subtitle2"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle2-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader2-subtitle3"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle3-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader2-subtitle4"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle4-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle4-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>

                                { /* Universus Infiniti European 20.20 S.L Referral Credits */}
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader2-subtitle5"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle5-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle5-text2"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/help">
                                        <u>
                                            <FormattedMessage
                                                id="terms-conditions-subheader2-subtitle5-text3"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                </Paragraph>

                                { /* CUBALICORES E-GIFT CARDS */ }
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader2-subtitle6"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle6-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle6-text2"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/help">
                                        <u>
                                            CubaLicores
                                        </u>
                                    </a>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle6-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle6-text4"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/help">
                                        <u>
                                            <FormattedMessage
                                                id="terms-conditions-subheader2-subtitle6-text5"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle6-text6"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle6-text7"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader2-subtitle7"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader2-subtitle7-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="terms-conditions-subheader3" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle1"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle1-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle1-text2"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/frequent-questions">
                                        <u>
                                            <FormattedMessage
                                                id="terms-conditions-subheader3-subtitle1-text3"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle1-text4"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/shipping-policy">
                                        <u>
                                            <FormattedMessage
                                                id="terms-conditions-subheader3-subtitle1-text5"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle1-text6"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/return-policy">
                                        <u>
                                            <FormattedMessage
                                                id="return-policy"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle1-text7"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle2"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle2-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle2-text2"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/return-policy">
                                        <u>
                                            <FormattedMessage
                                                id="return-policy"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    .
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle3"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle3-text1"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/frequent-questions">
                                        <u>
                                            <FormattedMessage
                                                id="terms-conditions-subheader3-subtitle1-text3"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    .
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle4"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle4-text1"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/privacy-policy">
                                        <u>
                                            <FormattedMessage
                                                id="terms-conditions-subheader2-subtitle5-text3"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle4-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle5"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle5-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle6"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text2-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text2-2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text2-3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text2-4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text2-5"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text2-6"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text3-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text3-2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text3-3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text4-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text4-2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text4-3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text4-4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text5"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text6"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text9"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text10"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle6-text11"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle7"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle7-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle8"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle8-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle9"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle9-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle9-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle10"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle10-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle10-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle10-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle10-text4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle11"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle11-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle12"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle13"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle12-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle14"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle14-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle15"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle15-text1"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <a href="https://www.cubalicores.com/privacy-policy">
                                        <u>
                                            <FormattedMessage
                                                id="privacy-policy"
                                                defaultMessage=""
                                            />
                                        </u>
                                    </a>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle15-text2"
                                        defaultMessage=""
                                    />
                                    {' '}
                                    <u>
                                        info@cubalicores.com
                                    </u>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle15-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader3-subtitle16"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader3-subtitle16-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage id="terms-conditions-subheader4" defaultMessage="" />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader4-text1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader4-text2"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader4-text2-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader4-text2-2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text2-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text2-2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text2-3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-3"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-4"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-5"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-6"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-7"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-8"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-9"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingLeft: 10 }}>
                                    {'- '}
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text3-10"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader5-text4"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text4-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader5-text5"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text5-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader5-text6"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text6-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader5-text7"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text7-1"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text7-2"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 0 }}>
                                    <strong className={styles.subtitle}>
                                        <FormattedMessage
                                            id="terms-conditions-subheader5-text8"
                                            defaultMessage=""
                                        />
                                    </strong>
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text9"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph style={{ paddingBottom: 3 }}>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text10"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                                <Paragraph>
                                    <FormattedMessage
                                        id="terms-conditions-subheader5-text13"
                                        defaultMessage=""
                                    />
                                </Paragraph>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

export default injectIntl(ReturnPolicy);



/** WEBPACK FOOTER **
 ** ./src/components/pages/terms-conditions.jsx
 **/